import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
import { StyledStatisticComponent } from "./statistic-component.scss";

const DEFAULT_STAT_CONTENT = {
  topic: {}
};

const StatisticComponent = ({ statics, advancedStaticsConfig }) => (
  <StyledStatisticComponent
    lineColor={statics?.lineColor}
    lineMargin={advancedStaticsConfig?.lineMargin}
    className="statistic-component"
  >
    <div className="vertical-line" />
    <FullParagraph {...DEFAULT_STAT_CONTENT} {...statics} {...advancedStaticsConfig} />
  </StyledStatisticComponent>
);

export default StatisticComponent;
